import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import AvatarHeader from '../../../AvatarHeader';

const MenuHeader = () => (
    <header className="p-l-16 p-r-16 p-b-12">
        <small className="text-upper tbody-7 text-bold">
            <I18n k="header.business_visitor.account" />
        </small>
        <AvatarHeader />
    </header>
);

export default MenuHeader;
